var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAskChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_360_798)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.1173 10.1221L10.7804 11.7337C10.0998 11.9896 9.56543 12.5212 9.31231 13.2018L7.70074 17.5443L6.08918 13.2018C5.83606 12.5212 5.30168 11.9868 4.62106 11.7337L0.28418 10.1221L4.62106 8.51057C5.30168 8.25744 5.83606 7.72307 6.08918 7.04244L7.70074 2.70557L9.31231 7.04244C9.56543 7.72307 10.0998 8.25744 10.7804 8.51057L15.1173 10.1221Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6553 5.57625L15.8497 6.24844C15.8047 6.26531 15.7681 6.30469 15.7484 6.34969L15.0791 8.15531L14.4069 6.34969C14.39 6.30469 14.3563 6.26813 14.3056 6.24844L12.5 5.57625L14.3056 4.90688C14.3534 4.89 14.3872 4.85063 14.4069 4.80563L15.0791 3L15.7484 4.80563C15.7653 4.85063 15.8047 4.88719 15.8497 4.90688L17.6553 5.57625Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7378 1.82257L11.8125 2.16851C11.7647 2.18538 11.7309 2.22476 11.7112 2.26976L11.3653 3.19507L11.0222 2.26976C11.0053 2.22476 10.9659 2.18819 10.9181 2.16851L9.99561 1.82257L10.9181 1.47944C10.9659 1.46257 11.0053 1.42319 11.0222 1.37538L11.3653 0.452881L11.7112 1.37538C11.7281 1.42319 11.7619 1.46257 11.8125 1.47944L12.7378 1.82257Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_360_798"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAskChat);
export default __webpack_public_path__ + "static/media/ask-chat.a54b33a44ba5825ba96f81de2056a714.svg";
export { ForwardRef as ReactComponent };